import { render } from "./ImageCard.vue?vue&type=template&id=1c31de62&scoped=true"
import script from "./ImageCard.vue?vue&type=script&lang=js"
export * from "./ImageCard.vue?vue&type=script&lang=js"

import "./ImageCard.vue?vue&type=style&index=0&id=1c31de62&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c31de62"]])

export default __exports__